<!-- 产品统计 -->
<template>
  <div class="content">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="SKU" name="sku" />
      <el-tab-pane label="SPU" name="spu" />
      <el-tab-pane label="品类" name="category" />
    </el-tabs>
    <list :searchType="searchType" ref="list"></list>
  </div>
</template>

<script>


import list from './components/list'
import _ from 'lodash'
export default {
  name: 'statistics_productStatistics',
  components: {
   list
  },
  data() {
    return {
      activeName: 'sku',
    }
  },
  computed: {
    searchType() {
      switch (this.activeName) {
        case 'spu':
          return 2
        case 'category':
          return 3
        default:
          return 1
      }
    }
  },
  mounted() {
    // this.$refs.list.changeTabs(this.searchType)
  },
  methods: {
    handleClick() {
      this.$refs.list.changeTabs(this.searchType)
    },
  }
}
</script>

<style lang="scss" scoped>
.content {
  min-width: 1200px;
  height: 100%;
  background: #ffffff;
  padding: 12px 12px 0;
}

</style>
